import { forwardRef, type ComponentProps } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { isPlainClick, withViewTransition } from "@/lib/viewTransition";

/**
 * A link to another of the site's places, moved to as a view transition
 * (lib/viewTransition). Everything else about it is a router Link. Its
 * callers name it with `actionProps`, as for a Link (lib/controlCoverage.test).
 */
const PlaceLink = forwardRef<HTMLAnchorElement, ComponentProps<typeof RouterLink>>(
    function PlaceLink({ onClick, to, replace, state, ...props }, ref) {
        const navigate = useNavigate();
        return (
            <RouterLink
                {...props}
                ref={ref}
                to={to}
                replace={replace}
                state={state}
                onClick={(event) => {
                    onClick?.(event);
                    if (!isPlainClick(event) || props.target === "_blank" || props.reloadDocument)
                        return;
                    event.preventDefault();
                    withViewTransition(() => navigate(to, { replace, state }));
                }}
            />
        );
    },
);

export default PlaceLink;
